var lang = require('/resources/lang/hu.json');

$(function () {
    "use strict"; // Start of use strict


});

function initClick(){
    $('.deleteRow').on('click', function(e) {
        e.preventDefault();
        $(this).parent().parent().remove();
    });
}

$(document).ready(function () {
    const dataTableSettings = {
        "bInfo": false,
        "paging": false,
        "searching":false,
        "info":false,
        "lengthMenu": false,
    }

    $('#dataTable').DataTable({
        ...dataTableSettings,
        "columnDefs": [{
            "targets": [4],
            "orderable": false
        }]
    });
    $('#dataTable-nav').DataTable({
        ...dataTableSettings,
        "columnDefs": [{
            "targets": [6],
            "orderable": false
        }]
    });
    $('#dataTable-content').DataTable({
        ...dataTableSettings,
        "columnDefs": [{
            "targets": [5],
            "orderable": false
        }]
    });

    $('#addFileRow').click( (e) => {
        e.preventDefault();
        $('#tableForFiles').show();
        initClick();
    });

    $(".js-add-unlock-codes").on("click", function(e) {
        event.preventDefault();
        $('<div class="row mb-3"><div class="col-4"><input type="text" name="new_unlock_codes[]" class="form-control"></div><div class="col-1"><a href="" class="js-remove-unlock-code btn btn-danger">-</a></div></div>').appendTo("#unlockCodes");
        $(".js-remove-unlock-code").on("click", function(e){
            e.preventDefault();
            $(this).parent().parent().remove();
        });
    });

    $(".js-remove-unlock-code").on("click", function(e){
        e.preventDefault();
        $(this).parent().parent().remove();
    });

});
